import { render, staticRenderFns } from "./Distpicker-b.vue?vue&type=template&id=c5f8874c"
import script from "./Distpicker-b.vue?vue&type=script&lang=js"
export * from "./Distpicker-b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports